import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Listing } from 'models/Listing';
import utils from 'utils';
import api from 'api';
import { SectionTitlePlaceholder } from '../../pages/Business/placeholders';
import CorrectTierCard from 'components/CorrectTierCard';
import useListingCardPlaceholder from 'hooks/useListingCardPlaceholder';

import './SimilarListings.styles.scss';

const LIMIT = '3';

type SimilarListingsProps = {
  className?: string;
  listingId: string;
  isLoading: boolean;
};

const SimilarListings: React.FC<SimilarListingsProps> = (props) => {
  const { className, listingId, isLoading } = props;

  const [isFetching, setIsFetching] = useState(true);
  const [similarListings, setSimilarListings] = useState<Listing[]>();

  const classes = classNames('similar-listings', className);

  const { t } = useTranslation();

  const SimmilarPlaceholders = useListingCardPlaceholder(+LIMIT);

  const SimilarListingCardArray = useMemo(
    () =>
      similarListings?.map((listing) => (
        <CorrectTierCard
          key={listing._id}
          listing={listing}
          updateListing={(listingId, updatedValues) =>
            setSimilarListings((old) =>
              old.map((el) =>
                el._id !== listingId ? el : { ...el, ...updatedValues },
              ),
            )
          }
        />
      )),
    [similarListings],
  );

  useEffect(() => {
    listingId &&
      !utils.isSSGHuman() &&
      (async () => {
        setIsFetching(true);
        try {
          const { data } = await api.listings.getSimilarListings(listingId, {
            $limit: LIMIT,
          });
          setSimilarListings(data);
        } catch (e) {
          return;
        } finally {
          setIsFetching(false);
        }
      })();
  }, [listingId]);

  return (
    <div className={classes}>
      {isLoading ? (
        <SectionTitlePlaceholder />
      ) : (
        <h2>{t('similarBusinessesForSale')}</h2>
      )}

      <div className="similar-listings__cards">
        {isLoading || isFetching
          ? SimmilarPlaceholders
          : similarListings?.length
          ? SimilarListingCardArray
          : null}
      </div>
    </div>
  );
};

export default SimilarListings;
